module.exports = __webpack_public_path__ + "static/media/about-berlin.99f9d374.mp4";